import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useLastLocation = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/auth/sign-in") {
      localStorage.setItem("lastLocation", JSON.stringify(location));
    }
  }, [location]);
};

export default useLastLocation;
